import { render, staticRenderFns } from "./SchemeTable.vue?vue&type=template&id=1be21c89&scoped=true"
import script from "./SchemeTable.vue?vue&type=script&lang=js"
export * from "./SchemeTable.vue?vue&type=script&lang=js"
import style0 from "./SchemeTable.vue?vue&type=style&index=0&id=1be21c89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be21c89",
  null
  
)

export default component.exports